import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResponseObj } from '../ai-interface';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-dynamic-content-ai',
  templateUrl: './dynamic-content-ai.component.html',
  styleUrls: ['./dynamic-content-ai.component.css']
})
export class DynamicContentAiComponent implements OnInit {
  @Input() data?: string; // la ricevi come stringa
  @Input() isProcessed: boolean = false
  @Output() outSelectedItem = new EventEmitter()
  parsedData: Array<{ type: 'text' | 'json'; value: ResponseObj }> = [];
  selectedItems = []
  protected mapType = {
    'list': 'none',
    'choice': 'single',
    'multi-choice': 'multiple'
  }
  constructor(private readonly ComponentService: ComponentService) { }

  ngOnInit() {
    this.parsedData = this.parseJsonString(this.data);
    console.log(this.parsedData)
  }

  onSelectionChanged(event: any) {
  }
  openPopUp() {
    const guid = Math.random().toString().replace("0.", "")
    const instanceData = {
      orientamento: "l",
      name: "dynamicList",
      formato: "a4",
      titoloGriglia: "'<h4>Elenco Procedure<h4/>'",
      masterKey: 'id',
      modifica: false,
      elimina: false,
      aggiungi: false,
      gridHeight: "700",
      classe: "mx-auto",
      ricerca: false,
      soloRicercaGlobale: true,
      isExportPDFAvailable: false,
      isExportDocxAvailable: false,
      isExportExcelAvailable: false,
      remoteOperations: true,
      dxocolumnchooser: false,
      paginate: false,
      dxoscrolling: "virtual",
      service: "crmProcedureGrid",
      showCheckBoxesMode: "always",
      selectRow: "single",
      api: "soggetto",
      pageSize: "50",
    }
    this.ComponentService.setNewPopUp(guid, 'NicaAnagraficaComponent', null, '600', true, instanceData, false, false, 'cicici')
    this.ComponentService.outputComponent.subscribe(currentOutput => {
      console.log(currentOutput)
    })

  }
  confirmSelect() {
    const ref = this.parsedData.filter((el) => el.type === 'json').map((el) => el.value.ref)
    const data: string[] = []
    for (const item of this.selectedItems) {
      for (const key of ref) {
        if (item[key.displayExpr]) {
          data.push(item[key.displayExpr])
        } else continue

      }
    }
    this.outSelectedItem.emit({ 'name': 'selection', data })
    this.isProcessed = true
  }

  private parseJsonString(rawText?: string): Array<{ type: 'text' | 'json'; value: any }> {
    const result: Array<{ type: 'text' | 'json'; value: any }> = [];

    if (!rawText) return [{ type: 'text', value: '' }];

    // se non c'è ```json, tutto testo
    if (!rawText.includes('```json')) {
      return [{ type: 'text', value: rawText.trim() }];
    }

    const regex = /```json\s*([\s\S]*?)```/gi;
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = regex.exec(rawText)) !== null) {
      const textBefore = rawText.slice(lastIndex, match.index).trim();
      if (textBefore) result.push({ type: 'text', value: textBefore });

      const jsonRaw = match[1].trim();
      try {
        const parsed = JSON.parse(jsonRaw);
        result.push({ type: 'json', value: parsed });
      } catch {
        result.push({ type: 'text', value: jsonRaw });
      }

      lastIndex = regex.lastIndex;
    }

    const remaining = rawText.slice(lastIndex).trim();
    if (remaining) result.push({ type: 'text', value: remaining });

    return result.length ? result : [{ type: 'text', value: rawText.trim() }];
  }
}
